import { PurchaseFlag, StageId } from "../types";
import { STAGE_ORDER } from "../config";

const STORAGE_KEY = "textInvaders.longMode";
const FREE_MAX_STAGE: StageId = "S2";

/** 購入ゲート管理 */
export class PurchaseGate {
  private flag: PurchaseFlag;

  constructor() {
    this.flag = this.readFlag();
  }

  private readFlag(): PurchaseFlag {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1" ? "LONG_MODE" : "FREE";
    } catch {
      return "FREE";
    }
  }

  /** 長文モードを解放 */
  unlockLongMode(): void {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // localStorage使用不可環境では無視
    }
    this.flag = "LONG_MODE";
  }

  /** 現在のフラグ取得 */
  getFlag(): PurchaseFlag {
    return this.flag;
  }

  /** FREEならS2上限を適用 */
  applyGate(stage: StageId): StageId {
    if (this.flag === "FREE") {
      const gateIdx = STAGE_ORDER.indexOf(FREE_MAX_STAGE);
      const stageIdx = STAGE_ORDER.indexOf(stage);
      return stageIdx > gateIdx ? FREE_MAX_STAGE : stage;
    }
    return stage;
  }
}
